import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth.js';

export const router = createRouter({
  history: createWebHashHistory('/pos/'),
  routes: [
    // ── Device pairing (first launch) ────────────────────────────────────
    {
      path: '/pair',
      name: 'pair-device',
      component: () => import('../pages/PairDevice.vue'),
    },

    // ── Staff PIN login ───────────────────────────────────────────────────
    {
      path: '/pin',
      name: 'staff-pin',
      component: () => import('../pages/StaffPin.vue'),
    },

    // ── Protected: requires paired device + authenticated staff ───────────
    {
      path: '/',
      name: 'pos',
      component: () => import('../pages/POS.vue'),
      meta: { requiresPosAuth: true },
    },
    {
      path: '/sessions',
      name: 'sessions',
      component: () => import('../pages/Sessions.vue'),
      meta: { requiresPosAuth: true },
    },
    {
      path: '/shift/open',
      name: 'shift-open',
      component: () => import('../pages/ShiftOpen.vue'),
      meta: { requiresPosAuth: true },
    },
    {
      path: '/shift/close',
      name: 'shift-close',
      component: () => import('../pages/ShiftClose.vue'),
      meta: { requiresPosAuth: true },
    },

    // ── Fallback ─────────────────────────────────────────────────────────
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();

  // Wait for Firebase Auth to restore the persisted device user before
  // making any routing decision — auth state is resolved asynchronously.
  await auth.initPromise;

  if (!auth.isPaired && to.name !== 'pair-device') {
    return { name: 'pair-device' };
  }

  if (auth.isPaired && !auth.isStaffAuthenticated && to.meta.requiresPosAuth) {
    return { name: 'staff-pin' };
  }
});
